import { Component } from 'react'
import ZoneForm from '../forms/popups/ZoneForm'
import Modal from '.'

interface AddZoneModalProps {
  fetchList: (list: string) => void
  createItem: (data: any) => void
  showToast: (options: { title: string }) => void
  isOpen: boolean
}

export class AddZoneModal extends Component<AddZoneModalProps> {
  handleSubmit = () => {
    const { fetchList, createItem, showToast } = this.props
    createItem({
      url: 'list/zones',
      onComplete: () => {
        showToast({ title: 'Added a Zone' })
        fetchList('residents')
        fetchList('zones')
      }
    })
  }

  render() {
    const { isOpen, ...formProps } = this.props
    if (!isOpen) return null

    return (
      // @ts-ignore
      <ZoneForm formId={MODAL_ID} onSubmit={this.handleSubmit} {...formProps} />
    )
  }
}

const MODAL_ID = 'addZone'

export default Modal(AddZoneModal, MODAL_ID)
